import "./TableCellStatusPill.scss";

type TableCellStatusPillVariant =
  | "success"
  | "warning"
  | "info"
  | "error"
  | "neutral";

type TableCellStatusPillProps = {
  /** the text to display in the pill */
  label: string;
  /** the color variant of the pill */
  variant: TableCellStatusPillVariant;
};

/**
 * maps common status strings to pill variants
 */
export const getStatusVariant = (
  status: string,
): TableCellStatusPillVariant => {
  // normalize: uppercase and replace spaces with underscores
  const normalizedStatus = status?.toUpperCase().replace(/\s+/g, "_");

  switch (normalizedStatus) {
    case "COMPLETED":
    case "SUCCESS":
    case "ACTIVE":
      return "success";
    case "IN_PROGRESS":
    case "PROCESSING":
      return "warning";
    case "PENDING":
    case "QUEUED":
      return "info";
    case "FAILED":
    case "ERROR":
    case "CANCELLED":
      return "error";
    default:
      return "neutral";
  }
};

/**
 * formats status text for display (e.g., "IN_PROGRESS" -> "In Progress")
 */
export const formatStatusLabel = (status: string): string => {
  if (!status) return "-";

  return status
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
};

/**
 * reusable colored pill component for displaying status values in table cells
 */
export const TableCellStatusPill = ({
  label,
  variant,
}: TableCellStatusPillProps) => {
  return (
    <span
      className={`table-cell-status-pill table-cell-status-pill--${variant}`}
    >
      {label}
    </span>
  );
};

export default TableCellStatusPill;
